import { useEffect, useState } from 'react';
import styles from './RequestTypeForms.module.scss';
import { statesWithId } from '../../../../components/body/support/forms/shared/FormsData';
import {
  normalizeInput,
  validateCode,
} from '../../../../components/body/checkout/sections/checkoutUtils';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from '../../../../src/app/hooks';
import { submitSupportTicket } from '../../../../src/features/user/userState';
import {
  VALIDATION_MESSAGES,
  validationTypes,
} from '../../../../commons/validations';
import {
  addressFormater,
  cleanEmailField,
  cleanNameField,
  phoneNumberLengthValidation,
  processCityField,
  processEmailField,
  processNameField,
} from '../../../../commons/formatters';
import {
  removeCountryCodeAndFormat,
  setFormDataFieldValue,
} from '../../../../commons/utils/utils';
import { intervalConversion, intervals } from '../../../../utils/Utils';
import {
  ADD1_REGISTER,
  ADD2_REGISTER,
  CITY_REGISTER,
  COMMENTS_REGISTER,
  EMAIL_REGISTER,
  FN_REGISTER,
  LN_REGISTER,
  PHONE_REGISTER,
  STATE_REGISTER,
  ZIP_REGISTER,
} from '../../../../commons/Constants';
import {
  ContainedButton,
  CountryDropdown,
  TextInput,
} from '../../../../commons/hoc';
import DatepickerComponent from '../../../../utils/Datepicker';
import TextAreaInput from '../../../../commons/hoc/Input/TextAreaInput/TextAreaInput';
import { BaseAddress } from '../../checkout/components';
import { Dropdown } from '../../../../commons/components/ui';

export default function Restart({
  currentOption,
  setFormSubmitted = () => {},
}) {
  const dispatch = useAppDispatch();
  const [nextOrderDate, setNextOrderDate] = useState(new Date());
  const [dateValue, setDateValue] = useState(null);
  const [dataError, setDataError] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [zipCode, setZipCode] = useState('');
  statesWithId[0] = { ...statesWithId[0], alias: '', disabled: false };
  const [currentAddress, setCurrentAddress] = useState({});

  const {
    register,
    formState,
    formState: { errors },
    handleSubmit,
    clearErrors,
    trigger,
    getValues,
    setValue,
  } = useForm({ mode: 'onBlur', reValidateMode: 'onBlur' });
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const onSubmit = (data) => {
    if (!dateValue) {
      setDataError(true);
    } else {
      dispatch(
        submitSupportTicket({
          'qmonitorid': 50,
          'firstname': data.firstName,
          'lastname': data.lastName,
          'phone': removeCountryCodeAndFormat(data.phone, true),
          'email': data.email,
          'Custom[638]': data.address1,
          'Custom[639]': data.address2,
          'Custom[640]': data.city,
          // 'Custom[642]': data.state.substring(0, 2),
          'Custom[642]': statesWithId[data.state].alias,
          'Custom[643]': data.zip,
          'Custom[967]':
            data.recurringInterval === 'PLACE_HOLDER_OPTION'
              ? ''
              : intervalConversion[data.recurringInterval]
                ? intervalConversion[data.recurringInterval]
                : '',
          'nextorderdata': nextOrderDate?.toLocaleDateString(),
          ...(data.comments && { message: data.comments }),
        })
      );
      setFormSubmitted(true);
    }
  };

  const handleInputOnChange = (key, value) => {
    setValue(key, value, { shouldValidate: false, shouldTouch: true });
    clearErrors(key);
  };

  const recurringInterval = register('recurringInterval', {
    required: false,
    onChange: (e) => {
      handleInputOnChange('recurringInterval', e.target.value);
    },
  });

  useEffect(() => {
    if (dateValue) {
      setDataError(false);
    }
  }, [dateValue]);

  const handleAutoComplete = (e) => {
    if (currentOption === 'restart') {
      // let target = e?.target?.form ? Array.from(e.target.form) : [];
      let target = e?.target?.form ? Array.from(e.target.form) : [];
      let tempFormData = {};
      target.forEach((item) => {
        if (item.name !== '') {
          tempFormData[item.name] =
            item.name === PHONE_REGISTER
              ? normalizeInput(item.value)
              : item.value;
        }
      });
      setFormDataFieldValue(getValues(), tempFormData, setValue, trigger);
      setPhoneNumber(getValues().phone);
      setZipCode(getValues().zip);
      clearErrors();
    }
  };

  /* useEffect(() => {
    if (typeof window === 'object') {
      import('detect-autofill').then((mod) => {
        window.addEventListener('onautocomplete', handleAutoComplete);
      });
    }
  }, []); */

  const handleAddressChange = (address, key) => {
    setValue(key, address, { shouldDirty: true });
  };

  const firstName = register(FN_REGISTER, {
    ...validationTypes.firstName,
    onChange: (e) => {
      e.target.value = processNameField(e.target.value);
      setValue(FN_REGISTER, e.target.value);
      clearErrors(FN_REGISTER);
    },
    onBlur: (e) => {
      setValue(FN_REGISTER, cleanNameField(e.target.value));
    },
  });

  const lastName = register(LN_REGISTER, {
    ...validationTypes.lastName,
    onChange: (e) => {
      e.target.value = processNameField(e.target.value);
      setValue(LN_REGISTER, e.target.value);
      clearErrors(LN_REGISTER);
    },
    onBlur: (e) => {
      setValue(LN_REGISTER, cleanNameField(e.target.value));
    },
  });

  const address1 = register(ADD1_REGISTER, {
    ...validationTypes.address1,
    onChange: (e) => {
      handleAddressChange(addressFormater(e.target.value), ADD1_REGISTER);
      clearErrors(ADD1_REGISTER);
    },
    onBlur: (e) => {
      handleAddressChange(
        addressFormater(e.target.value.trim()),
        ADD1_REGISTER
      );
    },
  });

  const address2 = register(ADD2_REGISTER, {
    ...validationTypes.address2,
    onChange: (e) => {
      handleAddressChange(addressFormater(e.target.value), ADD2_REGISTER);
      clearErrors(ADD2_REGISTER);
    },
    onBlur: (e) => {
      handleAddressChange(
        addressFormater(e.target.value.trim()),
        ADD2_REGISTER
      );
    },
  });

  const city = register(CITY_REGISTER, {
    ...validationTypes.city,
    onChange: (e) => {
      setValue(CITY_REGISTER, processCityField(e.target.value));
      clearErrors(CITY_REGISTER);
    },
    onBlur: (e) => {
      setValue(CITY_REGISTER, e.target.value.trim());
    },
  });

  const zip = register(ZIP_REGISTER, {
    ...validationTypes.zip,
    onChange: (e) => {
      setZipCode(validateCode(e.target.value, zipCode, 5));
      clearErrors(ZIP_REGISTER);
    },
  });

  const phone = register(PHONE_REGISTER, {
    ...validationTypes.phone,
    onBlur: (e) => {
      setPhoneNumber(normalizeInput(e.target.value, phoneNumber));
    },
    onChange: (e) => {
      clearErrors(PHONE_REGISTER);
      let number = phoneNumberLengthValidation(e.target.value);
      if (number !== null) {
        setPhoneNumber(number);
      }
    },
  });

  const email = register(EMAIL_REGISTER, {
    ...validationTypes.email,
    onChange: (e) => {
      setValue(EMAIL_REGISTER, processEmailField(e.target.value));
      clearErrors(EMAIL_REGISTER);
    },
    onBlur: (e) => {
      setValue(EMAIL_REGISTER, cleanEmailField(e.target.value));
    },
  });

  const comments = register(COMMENTS_REGISTER, {
    required: false,
  });

  const datepickerProps = { minDate: new Date(), variant: 'inline' };

  const handlePhoneNumber = (event) => {
    setPhoneNumber(event.target.value.replace(/\D/g, ''));
  };

  return (
    <div className={styles.supportFormsContainer}>
      <form onSubmit={handleSubmit(onSubmit)} id="form-restart">
        {/* For safer side - Don't Delete below commented code */}
        {/* <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="First Name"
              required={validationTypes.firstName.required}
              register={firstName}
              maxLength={validationTypes.firstName.maxLength}
              errors={errors}
              placeholder="First Name"
            />
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="Last Name"
              required={validationTypes.lastName.required}
              register={lastName}
              maxLength={validationTypes.lastName.maxLength}
              errors={errors}
              placeholder="Last Name"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              type="tel"
              inputMode="numeric"
              register={phone}
              required={validationTypes.phone.required}
              label="Phone Number"
              placeholder="(XXX) XXX-XXXX"
              onFocus={handlePhoneNumber}
              onClickCapture={handlePhoneNumber}
              errors={errors}
              maxLength={validationTypes.phone.maxLength}
              value={phoneNumber}
            />
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              required={validationTypes.email.required}
              register={email}
              label="Email Address"
              maxLength={validationTypes.email.maxLength}
              errors={errors}
              placeholder="Email Address"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerSingle}>
            <TextInput
              required={validationTypes.address1.required}
              register={address1}
              label="Address - Line 1"
              maxLength={validationTypes.address1.maxLength}
              errors={errors}
              placeholder="Address - Line 1"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerSingle}>
            <TextInput
              register={address2}
              label="Address - Line 2"
              maxLength={validationTypes.address2.maxLength}
              errors={errors}
              placeholder="Address - Line 2"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerSingle}>
            <TextInput
              required={validationTypes.city.required}
              register={city}
              label="City"
              maxLength={validationTypes.city.maxLength}
              errors={errors}
              placeholder="City"
            />
          </div>
        </div>
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerDouble}>
            <label>State*</label>
            <CountryDropdown
              id="restartStateId"
              name={STATE_REGISTER}
              // label={'State'}
              tkey="title"
              options={Object.values(statesWithId)}
              {...register(STATE_REGISTER, { required: true })}
              optionsOrder={[1, 2]}
              required={validationTypes.state.required}
              onChange={(e) =>
                handleInputOnChange(STATE_REGISTER, e.target.value)
              }
              // errorType={STATE}
              // error={errors[formKeyMap[STATE]]?.type ? true : false}
            />
            {getValidationMessage(errors, STATE_REGISTER)}
          </div>
          <div className={styles.inputBoxContainerDouble}>
            <TextInput
              label="Zip Code"
              required={validationTypes.zip.required}
              register={zip}
              maxLength={validationTypes.zip.maxLength}
              errors={errors}
              placeholder="Zip Code"
            />
          </div>
        </div>
        */}
        <BaseAddress
          key=""
          id=""
          rdxUpdateAddressCB={(address) => setCurrentAddress(address)}
          hookFormCB={{
            register,
            formState,
            handleSubmit,
            clearErrors,
            trigger,
            getValues,
            setValue,
          }}
          isSupportPage={true}
          data={currentAddress}
        />
        <div className={styles.inputRowContainer}>
          <div className={styles.inputBoxContainerSingle}>
            <TextInput
              required={validationTypes.email.required}
              register={email}
              label="Email Address"
              isDarkBorder={true}
              maxLength={validationTypes.email.maxLength}
              errors={errors}
              placeholder="Email Address"
            />
          </div>
        </div>
        <div className={styles.nextOrderDate}>
          <label>My Next Order Date*</label>
          <div className={styles.datepickerContainer}>
            {mounted &&
              DatepickerComponent(
                dateValue || null,
                setDateValue,
                nextOrderDate,
                setNextOrderDate,
                {
                  minDate: new Date(),
                  variant: 'inline',
                  autoOk: true,
                }
              )}
          </div>
        </div>
        {dataError && (
          <div className={styles.nextOrderDateRequired}>
            {VALIDATION_MESSAGES.NEXT_ORDER_DATE}
          </div>
        )}
        <div className={styles.nextOrderDateDisclaimer}>
          Please Note: This is the date we will charge you for your order. If
          the date you select falls on a weekend or holiday, we will ship on
          approximately the next business day.
        </div>
        <div className={styles.shippingFrequency}>
          <label>Shipping Frequency</label>
          <CountryDropdown
            options={intervals}
            name="recurringInterval"
            tkey="title"
            isDarkBorder={true}
            id="shipping-interval"
            addNewOption={false}
            selectLabel={true}
            selectDisable={false}
            label={'Interval'}
            {...recurringInterval}
            labelNeeded={false}
          />
        </div>
        <div className={styles.questionsCommentsContainer}>
          <label>Comments/Questions</label>

          <div className={styles.questionsComments}>
            <TextAreaInput
              className={styles.questionTextArea}
              id="questionsComments"
              minRows={4}
              isDarkBorder={true}
              onChange={(e) => {
                clearErrors(COMMENTS_REGISTER);
              }}
              register={comments}
            />
          </div>
          <div className={styles.sendButtonContainer}>
            <ContainedButton
              btnType="dark"
              className={styles.submitRequestButton}
            >
              Submit Request
            </ContainedButton>
          </div>
        </div>
      </form>
    </div>
  );
}
